var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_91700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2812 4.0625V1.71875H12.7031V0.5H11.2969V1.71875H8.71875V4.0625H0V19.5312H7.3125V24.5H8.71875V22.625H15.2812V24.5H16.6875V19.5312H24V4.0625H15.2812ZM10.125 3.125H13.875V4.0625H10.125V3.125ZM15.2812 21.2188H8.71875V19.5312H15.2812V21.2188ZM22.5938 18.125H1.40625V5.46875H22.5938V18.125Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 15.2188H6.1875V16.625H17.8125V15.2188Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_91700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg56);
export default __webpack_public_path__ + "static/media/56.42caab2ee0a1bbf0386f1a30ed362f84.svg";
export { ForwardRef as ReactComponent };